"use client";

import * as RadioGroup from "@radix-ui/react-radio-group";
import { SurveyQuestionResponse } from "@yardzen/api-dtos";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { SingleChoiceResponseType } from "../QuizQuestionHandler";
import { ResponseOptions } from "./ResponseOptions";
import { IconName } from "@yardzen/ui/components/icon";

export default function SingleChoiceResponse({
  options,
  surveyQuestionResponse,
  register,
  setValue,
}: {
  options: {
    text: string;
    value: string;
    icon: IconName;
  }[];
  surveyQuestionResponse?: SurveyQuestionResponse;
  setValue: UseFormSetValue<any>;
  register: UseFormRegister<any>;
}) {
  const response: SingleChoiceResponseType | null =
    surveyQuestionResponse?.response
      ? (JSON.parse(
          surveyQuestionResponse.response,
        ) as SingleChoiceResponseType)
      : null;

  const handleToggleClick = (value: string) => {
    setValue("response", value.toString(), {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  return (
    <RadioGroup.Root
      className="flex w-full flex-wrap justify-center gap-2"
      defaultValue={response?.value}
      onValueChange={handleToggleClick}
      {...register("response")}
    >
      <ResponseOptions
        options={options}
        responseType="single-choice"
        isSelected={(value) => response?.value === value}
      />
    </RadioGroup.Root>
  );
}
